import { useTranslation } from "@redotech/redo-i18n";
import {
  Channel,
  SalesChannels,
} from "@redotech/redo-order-common/sales-channels";
import type { SalesChannelState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useMemo } from "react";

export const SalesChannelDetails = memo(function SalesChannelDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<SalesChannelState>) {
  const { t } = useTranslation();
  const channelOptions: BadgeRedoListItem<string>[] = useMemo(
    () =>
      SalesChannels.map((channel: Channel) => ({
        id: channel.id,
        value: channel.id,
        type: "badge" as const,
        badge: { text: channel.displayName, color: "gray" as const },
      })),
    [],
  );

  const selectedOptions = useMemo(
    () => channelOptions.filter((option) => state.includes(option.value)),
    [channelOptions, state],
  );

  return (
    <RedoTagsDropdownInput
      disabled={disabled}
      label={t("Sales Channels")}
      options={channelOptions}
      placeholder={t("Select sales channels...")}
      selectedOptions={selectedOptions}
      setSelectedOptions={(items: BadgeRedoListItem<string>[]) => {
        setState(items.map((item) => item.value));
      }}
      size="xs"
    />
  );
});
